import {
  Assignment,
  AssignmentInd,
  DirectionsCar,
  DirectionsWalk,
  Security,
} from "@mui/icons-material";
import React from "react";

export const STEP_ICONS = {
  assignment: (props) => <Assignment {...props} />,
  security: (props) => <Security {...props} />,
  assignment_ind: (props) => <AssignmentInd {...props} />,
  directions_car: (props) => <DirectionsCar {...props} />,
  directions_walk: (props) => <DirectionsWalk {...props} />,
};
